export const CONSTANTS = {
  MIN_CONSUMPTION_KWH: 0.5,
  MIN_DURATION_SECS: 120,
  POLLING_INTERVAL: 1000,
  TRANSACTION_DELAY: 500,
  LOCAL_STORAGE_KEYS: {
    STATION_ID: "stationId",
    CONNECTOR_ID: "connectorId",
    SESSION_ID: "sessionId",
  },
} as const;
